import React from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorMessage.module.scss';


const ErrorMessage = ({ message }) => (
  <div className={styles.wrapper}>{message}</div>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorMessage;
